import { fetcher } from "helpers/fetcher";

import { TGetTagsReq, TGetTagsRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getTags = async (params?: TGetTagsReq) => {
  return await fetcher<TGetTagsRes, TGetTagsReq>(ENDPOINT.MANAGEMENT.GET_TAG, {
    params: params?.["data"],
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.MANAGEMENT.GET_TAG.version,
      [API_HEADER.BU_ID]: params?.idBu,
    },
  });
};

export const queryGetTags = async (params?: TGetTagsReq) => {
  return (await getTags(params)).data;
};

queryGetTags._key = (params?: TGetTagsReq) => [
  ENDPOINT.MANAGEMENT.GET_TAG.url,
  params,
];
